import Vue from 'vue'
import vuex from 'vuex'
import getters from './getters';

Vue.use(vuex);

// 引入子模块
import app from './modules/app'
import tab from './modules/tab'
import user from './modules/user'
import menu from './modules/menu'
import school from './modules/school';

const store = new vuex.Store({
    modules: {
        app: app,
        tab: tab,
        user: user,
        menu: menu,
        school,
    },
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js